<template>
  <div class="flex w-full flex-col gap-[15px]">
    <div
      v-for="product in store.bumProductList"
      :key="`bump-product-${product.priceId}-${product.productId}`"
      class="flex flex-col items-start self-stretch rounded-lg border-dashed border-gray-200"
    >
      <div
        class="flex items-center justify-between gap-2 self-stretch rounded-t-lg bg-indigo-600 px-3 py-[10px]"
        :style="{
          backgroundColor: '#' + store.payment.bumpSettings.bumpBackgroundColor,
        }"
      >
        <div class="flex items-center gap-2 self-stretch">
          <input :id="product.productId" :name="product._id" :value="product._id" type="checkbox" />
          <UITextSmMedium
            :style="{
              color: '#' + store.payment.bumpSettings.highlightTextColor,
            }"
            >{{ store.payment.bumpSettings.highlightText }}</UITextSmMedium
          >
          <img
            :src="
              BUMP_ICONS.find((icon) => icon.value === store.payment.bumpSettings.bumpIcon)
                ?.imageUrl
            "
            :alt="t('common.products.bumpIconAlt')"
            class="h-6 w-6"
            loading="lazy"
          />
        </div>
        <div
          v-if="store.payment.bumpSettings.showPrice"
          class="flex items-start gap-[5px] self-stretch"
          :style="{
            color: '#' + store.payment.bumpSettings.bumpPriceColor,
          }"
        >
          <UITextSmMedium
            v-if="product.compareAtPrice"
            class="overflow-hidden text-ellipsis line-through"
            >{{ store.currencyList[product.currency]?.symbol || "$" }}{{ product.compareAtPrice }}
          </UITextSmMedium>
          <UITextSmMedium
            >{{ store.currencyList[product.currency]?.symbol || "$"
            }}{{ product.amount }}</UITextSmMedium
          >
        </div>
      </div>
      <div class="flex items-start gap-2 self-stretch p-4">
        <div class="flex items-start gap-2 self-stretch">
          <img
            :key="`product-image-${product.productId}-${product.uploadedImage || product.image}`"
            :src="product.uploadedImage || product.image"
            :alt="t('common.products.productImageAlt')"
            class="h-20 w-20 rounded-lg"
            loading="lazy"
            @error="handleImageError"
          />
          <div class="flex flex-col items-start gap-2 self-stretch">
            <UITextSmMedium
              :style="{
                color: '#' + store.payment.bumpSettings.headlineColor,
              }"
              >{{ product.headline }}</UITextSmMedium
            >
            <UITextSmMedium
              :style="{
                color: '#' + store.payment.bumpSettings.otoHeadlineColor,
              }"
              >{{ product.otoHeadline }}</UITextSmMedium
            >
            <UITextSmMedium
              :style="{
                color: '#' + store.payment.bumpSettings.otoTextColor,
              }"
              >{{ product.otoText }}</UITextSmMedium
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UITextSmMedium } from "@gohighlevel/ghl-ui";

import { useAppStore } from "@/store/app";
import { BUMP_ICONS } from "@/util/productConstants";
import { useI18n } from "vue-i18n";
const store = useAppStore();
const { t } = useI18n();

const handleImageError = (event: Event) => {
  const img = event.target as HTMLImageElement;
  // Set a fallback image or hide the image element
  img.style.display = "none";
};
</script>

<style scoped></style>
